export const ADD_PAGE_SPINNER = "ADD_PAGE_SPINNER"
export const REMOVE_PAGE_SPINNER = "REMOVE_PAGE_SPINNER"
export const ADD_BUTTON_SPINNER = 'ADD_BUTTON_SPINNER'
export const REMOVE_BUTTON_SPINNER = 'REMOVE_BUTTON_SPINNER'